module.exports = __webpack_public_path__ + "img/Tanents icon.f349ef7.png";